import { render } from "./WizardStep.vue?vue&type=template&id=803525a2&scoped=true"
import script from "./WizardStep.vue?vue&type=script&lang=js"
export * from "./WizardStep.vue?vue&type=script&lang=js"

import "./WizardStep.vue?vue&type=style&index=0&id=803525a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803525a2"]])

export default __exports__